import axios from "axios"
import router from "@/router"

export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    items_set(state, val) {
      state.items = val
    }
  },

  getters: {
    loading: state => state.items.length === 0,

    // получение элемента по ID
    getCarStatus: state => id => state.items.carStatuses.find(item => item.id === id),
    getRequestStatus: state => id => state.items.requestStatuses.find(item => item.id === id),
    getRequestType: state => id => state.items.requestTypes.find(item => item.id === id),

    carCountries: state => state.items.carCountries,
    carOperationTypes: state => state.items.carOperationTypes,
    carStatuses: state => state.items.carStatuses,
    requestStatuses: state => state.items.requestStatuses,
    requestTypes: state => state.items.requestTypes,
    trackerTypes: state => state.items.trackerTypes
  },

  actions: {
    async init({ commit }) {
      try {
        const response = await axios.get("/directories")
        commit("items_set", response.data)
      } catch {
        router.push("/error?message=Ошибка при загрузке справочников")
      }
    }
  }
}
